import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Card.css";

function SixColumnCards() {
  return (
    <Container id="containercard">
      <hr></hr>
      <Row className="justify-content-center gy-3">
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card ">
            <Card.Img variant="top" src="./img/immagini/10.png" alt="fire" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/11.png" alt="pesce" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/12.png" alt="fire" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/13.png" alt="tartare" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/14.png" alt="plate" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/15.png" alt="orata" className="card-img" />
          </Card>
        </Col>
      </Row>
      <hr></hr>
    </Container>
  );
}

export default SixColumnCards;
